import React, { FC } from 'react';
import { Heading3 } from '@blueprint/heading';
import {
    StyledMenuList,
    StyledNavLink,
    SecondaryNavWrapper
} from './SecondaryNav.styles';

type Props = {
    parentTracking?: string;
    subNavs?: {
        label: string | null;
        position: number | null;
        type?: string | null;
        subitems: {
            datetime?: string | null;
            label: string | null;
            type?: string | null;
            order?: number | null;
            nofollow?: boolean | null;
            i18nLabelKey: string | null;
            tracking: string | null;
            uri: string | null;
        }[];
    }[];
};

const SecondaryNav: FC<Props> = ({ parentTracking, subNavs, children }) => (
    <SecondaryNavWrapper data-testid="header-primarynav-items">
        {subNavs?.map((item, idx) => (
            <React.Fragment key={'secondnav-' + idx}>
                {item.label !== '' ? (
                    <Heading3 size="8">{item.label}</Heading3>
                ) : (
                    ''
                )}
                <StyledMenuList key={idx}>
                    {item.subitems.map((links, index) => (
                        <React.Fragment key={'secondnav-item-' + index}>
                            {links.label ? (
                                <li>
                                    <StyledNavLink
                                        href={links.uri ? links.uri : ''}
                                        data-track-category="navbar"
                                        data-track-action="clickthrough"
                                        data-track-label={`${parentTracking}>${links.tracking}`}
                                        data-universal-header-menuitem="true"
                                        rel={links.nofollow ? 'nofollow' : ''}
                                    >
                                        {links.label}
                                    </StyledNavLink>
                                </li>
                            ) : (
                                ''
                            )}
                        </React.Fragment>
                    ))}
                </StyledMenuList>
            </React.Fragment>
        ))}
        {children}
    </SecondaryNavWrapper>
);

export default SecondaryNav;
